// @flow
/**
 * Main Flow Container. This will contain all the other container components.
 * This component is mounted at 'transfer/'.
 * If we ever move header/footer to React this is where it should live...
 */

import React from 'react'
import PropTypes from 'prop-types'
import clientData from 'utils/client-data'

import { SPINNER_ID } from 'utils/loader'
import { LoadingSpinner as Spinner } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'

Main.propTypes = {
  userHasCoverPhoto: PropTypes.string,
}

const SpinnerContainer = glamorous.div({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  animation: 'vx_fade-in 0.3s ease-out 0s both',
  zIndex: 1,
})

function Main(props) {
  return (
    <div>
      <SpinnerContainer id={SPINNER_ID} style={{ display: 'none' }}>
        <Spinner
          theme="v2"
          size="xl"
          screenReaderText={`l10n('spinner.loading')`}
        />
      </SpinnerContainer>
      <div className="react-p2p_wrapper">
        <div id="contents" className="contents vx_mainContent">
          {props.children}
        </div>
        <div
          style={{ zIndex: 800 }}
          dangerouslySetInnerHTML={{ __html: clientData.footerHtml }}
        />
      </div>
    </div>
  )
}

export default Main
